import Vue from 'vue'

export const state = {
  showedRoutes: {},
  formValues: {},
}

export const mutations = {
  INIT_SHOWEDROUTES(state, payload) {
    state.showedRoutes = payload
  },

  SET_SHOWEDROUTES(state, payload) {
    Vue.set(state.showedRoutes, payload.key, payload.value)
  },

  TOGGLE_ALL_SHOWEDROUTES(state, payload) {
    Object.keys(state.showedRoutes).forEach((key) => {
      Vue.set(state.showedRoutes, key, payload)
    })
  },

  RESET_SHOWEDROUTES(state) {
    state.showedRoutes = {}
  },
}

export const actions = {
  initShowedRoutes({ commit }, payload) {
    commit('INIT_SHOWEDROUTES', payload)
  },

  setShowedRoutes({ commit }, payload) {
    commit('SET_SHOWEDROUTES', payload)
  },

  toggleAllShowedRoutes({ commit }, payload) {
    commit('TOGGLE_ALL_SHOWEDROUTES', payload)
  },

  resetShowedRoutes({ commit }) {
    commit('RESET_SHOWEDROUTES')
  },
}
